module.exports = __webpack_public_path__ + "static/logo-sa-cdd30814b14c88280c96cbdf800d7c74.png";